import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que maneja el scroll automático al cambiar de ruta
 * y el scroll a secciones específicas con hash
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Si hay un hash, scroll a esa sección
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        
        if (element) {
          const headerOffset = 80; // Altura del header fijo
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Si no hay hash, scroll al inicio
      window.scrollTo({
        top: 0,
        behavior: 'instant' // Instantáneo para cambios de página
      });
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;